"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _input = _interopRequireDefault(require("./input.style"));

var _inputBehaviour = require("../input-behaviour");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Input = /*#__PURE__*/_react.default.forwardRef(({
  autoFocus,
  inputRef,
  onClick,
  onChangeDeferred,
  onChange,
  onBlur,
  onFocus,
  deferTimeout,
  type = "text",
  id,
  name,
  ...rest
}, ref) => {
  const context = (0, _react.useContext)(_inputBehaviour.InputContext);
  const groupContext = (0, _react.useContext)(_inputBehaviour.InputGroupContext);
  const deferredTimeout = (0, _react.useRef)(null);
  const input = ref || (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (autoFocus && input.current) input.current.focus();
  }, [autoFocus, input]);
  (0, _react.useEffect)(() => {
    if (inputRef) inputRef(input);
  }, [input, inputRef]);
  (0, _react.useEffect)(() => {
    if (context.inputRef) context.inputRef(input);
  }, [context, input]);

  const handleClick = ev => {
    if (onClick) onClick(ev);
    input.current.focus();
  };

  const handleFocus = ev => {
    if (onFocus) onFocus(ev);
    if (context.onFocus) context.onFocus(ev);
    if (groupContext.onFocus) groupContext.onFocus(ev);
    if (type === "text") selectTextOnFocus(input);
  };

  const handleBlur = ev => {
    if (onBlur) onBlur(ev);
    if (context.onBlur) context.onBlur(ev);
    if (groupContext.onBlur) groupContext.onBlur(ev);
  };

  const handleDeferred = ({
    currentTarget,
    target
  }) => {
    if (onChangeDeferred) {
      clearTimeout(deferredTimeout.current);
      deferredTimeout.current = setTimeout(() => {
        onChangeDeferred({
          currentTarget,
          target
        });
      }, deferTimeout || 750);
    }
  };

  const handleChange = ev => {
    if (onChange) onChange(ev);
    handleDeferred(ev);
  };

  return /*#__PURE__*/_react.default.createElement(_input.default, _extends({}, rest, {
    name: name,
    type: type,
    id: id || name,
    ref: input,
    "data-element": "input",
    onFocus: handleFocus,
    onBlur: handleBlur,
    onClick: handleClick,
    onChange: handleChange
  }));
});

Input.propTypes = {
  className: _propTypes.default.string,
  id: _propTypes.default.string,

  /** A callback to retrieve the input reference */
  inputRef: _propTypes.default.func,
  name: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  onClick: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  autoFocus: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onChangeDeferred: _propTypes.default.func,
  deferTimeout: _propTypes.default.number,
  type: _propTypes.default.string
};

function selectTextOnFocus(input) {
  // setTimeout is required so the dom has a chance to place the cursor in the input
  setTimeout(() => {
    if (input.current) {
      const {
        length
      } = input.current.value;
      const cursorStart = input.current.selectionStart;
      const cursorEnd = input.current.selectionEnd; // only select text if cursor is at the very end or the very start of the value

      if (cursorStart === 0 && cursorEnd === 0 || cursorStart === length && cursorEnd === length) {
        if (document.activeElement === input.current) {
          input.current.setSelectionRange(0, length);
        }
      }
    }
  });
}

var _default = Input;
exports.default = _default;